import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var trackDetailsRes;
export const trackDetailsTodo = createAsyncThunk('trackDetails', async (id) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'course/view_learning_path_details',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "learning_id": id,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return trackDetailsRes = res.data
    } catch (error) {
        return trackDetailsRes = error.response.data
    }
})


const trackDetailsSlice = createSlice({
    name: 'trackDetails',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(trackDetailsTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('trackDetails', state.data)
            }
        });
        builder.addCase(trackDetailsTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default trackDetailsSlice.reducer; 